import { z } from 'zod';

export const ProcessSchema = z.object({
  businessAreaId: z.coerce
    .number({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  description: z
    .string()
    .max(255, {
      message: `error.field_max_lengh_255`,
    })
    .optional(),
  processName: z
    .string({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  processOwnerId: z.coerce
    .number({ message: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
});

export type FormProcessSchemaType = z.infer<typeof ProcessSchema>;

export interface ProcessSchemaType extends FormProcessSchemaType {
  id?: number;
}
